<template>
  <div>
    <Banner />
    <RequestCard />
    <ServicesCard />
    <FunFactCard />
    <MoreInfoCard />
    <!-- <TestimonialCard /> -->
    <CallbackRequestCard class="mb-4" />
    <!-- <PartnersCard /> -->
  </div>
</template>

<script>
import Banner from "@/components/CustomBanner.vue";
import RequestCard from "@/components/RequestCard.vue";
import ServicesCard from "@/components/ServicesCard.vue";
import FunFactCard from "@/components/FunFactCard.vue";
import MoreInfoCard from "@/components/MoreInfoCard.vue";
import CallbackRequestCard from "@/components/CallbackRequestCard.vue";
export default {
  name: "HomeView",
  components: {
    Banner,
    RequestCard,
    ServicesCard,
    FunFactCard,
    MoreInfoCard,
    CallbackRequestCard,
  },
};
</script>
